import './joinRoom.css';
import { useContext, useState, useEffect } from 'react';
import { Grid, Card, CardContent, TextField } from '@material-ui/core'
import Button from 'components/Styled/Button/Button';
import socketProvider from 'components/Provider/SocketProvider';
import { joinRoom as join, joinRoomByCookie } from 'services/socketEmitEvent';

function JoinRoom({ roomName }) {
    const socket = useContext(socketProvider);
    
    const [playerName, setPlayerName] = useState('');

    useEffect(() => {
        if(socket){
            joinRoomByCookie(socket);
        }
        
    }, [socket])

    const onPlayerNameChange = (e)=>{
        setPlayerName(e.target.value)
    }

    const joinRoom = ()=>{
        if(playerName){
            join(socket, roomName, playerName)
        }
    }

    return(
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ minHeight: '100vh' }}
        >
            <Card>
                <CardContent>
                    <h1 id="title">Rejoindre une partie</h1>
                    <div>
                        <TextField 
                            name='playerName' 
                            label='Pseudo'
                            variant="outlined"
                            fullWidth
                            color='secondary'
                            margin='dense'
                            onChange={onPlayerNameChange}
                        />
                        <Button
                            disabled={!playerName}
                            onClick={joinRoom}
                        >
                            Valider
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </Grid>
    )
}

export default JoinRoom;